import { render } from "./UsersCard.vue?vue&type=template&id=2e36cf2b"
import script from "./UsersCard.vue?vue&type=script&lang=js"
export * from "./UsersCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__